import { Tooltip } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import { MyTableHeader } from 'components/MyTable/';
import Spin from 'components/Spin';
import moment from 'moment';
import React, { useState, useCallback } from 'react';
import { FormattedNumber } from 'react-intl';
import { toast } from 'react-toastify';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableEmpty from 'v2/components/Shared/MyTable/MyTableEmpty';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import shoppingService from 'v2/services/shopping/subscription';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import useStyle from './../styles';

const headers = [
  { title: '', ordering: false },
  { title: 'Fatura', ordering: false },
  { title: 'Pagamento', ordering: false },
  { title: 'Valor', numeric: true, ordering: false },
];

interface PaymentHistoryProps {
  delivery: ShoppingDelivery;
}

export const PaymentHistory = ({ delivery }: PaymentHistoryProps) => {
  const classes = useStyle();

  const [loadingHistory, setLoadingDocument] = useState<boolean>(false);
  const [history, setHistory] = useState([]);

  const handleClickHistory = useCallback((subscriptionId: number) => {
    setLoadingDocument(true);
    shoppingService.loadSubscriptionHistory(subscriptionId).subscribe((res) => {
      setHistory(res.data);
      setLoadingDocument(false);
    }, toast.error);
  }, []);

  return (
    <MyCollapse title='Histórico de Pagamento' onClick={() => handleClickHistory(delivery.subscription_id)} arrow>
      {loadingHistory && <Spin />}

      {!loadingHistory && (
        <MyTable responsive>
          <MyTableHeader index={headers} />
          <MyTableEmpty data={history} colSpan={headers.length} />
          <MyTableBody>
            {history?.map((item: any) => (
              <MyTableRow key={`item-${item.id}`}>
                <MyTableCol status screenSizes={{ xs: 4, sm: 2 }}>
                  <Tooltip placement='top' title={item.payment_status.name}>
                    <div className={`${classes.tableStatus} ${item.payment_status.alias}`} />
                  </Tooltip>
                </MyTableCol>
                <MyTableCol screenSizes={{ xs: 8, sm: 3 }}>{item.id}</MyTableCol>
                <MyTableCol screenSizes={{ xs: 8, sm: 4 }}>{item.received_at ? moment(item.received_at).format('L') : '-'}</MyTableCol>
                <MyTableCol numeric screenSizes={{ xs: 4, sm: 4 }}>
                  <FormattedNumber value={item.amount} format='BRL' />
                </MyTableCol>
              </MyTableRow>
            ))}
          </MyTableBody>
        </MyTable>
      )}
    </MyCollapse>
  );
};
